
addEventListener('DOMContentLoaded', () => {
	const fieldIcons = document.querySelector('.field.input.icons.icon')
	if (fieldIcons) {
		handleClicks(fieldIcons)
	}
})

function handleClicks(fieldIcons) {

	const input = fieldIcons.querySelector('input[type=hidden]')
	const icons = fieldIcons.querySelectorAll('div.icon')

	icons.forEach(icon => {
		icon.addEventListener('click', (e) => {
			input.value = icon.getAttribute('data-class')

			resetIcons()
			icon.classList.add('selected')
		})
	});

	function resetIcons() {
		icons.forEach(icon => {
			icon.classList.remove('selected')
		})
	}

}
